import { Handyman } from "./handyman";
import { Healing } from "./healing";
import { HealthAndSafety } from "./health_and_safety";
import { Help } from "./help";
import { HistoryEdu } from "./history_edu";
import { Home } from "./home";

const iconsList = [
  { label: "Handyman", code: <Handyman /> },
  { label: "Healing", code: <Healing /> },
  { label: "HealthAndSafety", code: <HealthAndSafety /> },
  { label: "Help", code: <Help /> },
  { label: "HistoryEdu", code: <HistoryEdu /> },
  { label: "Home", code: <Home /> },
];

export {
  iconsList,
  Handyman,
  Healing,
  HealthAndSafety,
  Help,
  HistoryEdu,
  Home,
};
